
import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const Product2Page = lazy(() => import('../pages/product-2/page'));
const ProductWarmthPage = lazy(() => import('../pages/product-warmth/page'));
const ProductRecoveryPage = lazy(() => import('../pages/product-recovery/page'));
const ProductVitalityPage = lazy(() => import('../pages/product-vitality/page'));
const ProductBreathPage = lazy(() => import('../pages/product-breath/page'));
const ProductFreshnessPage = lazy(() => import('../pages/product-freshness/page'));
const ProductBrainPage = lazy(() => import('../pages/product-brain/page'));
const BoardPage = lazy(() => import('../pages/board/page'));
const BoardDetailPage = lazy(() => import('../pages/board-detail/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">로딩 중...</div>}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: '/product/1',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">로딩 중...</div>}>
        <ProductDetailPage />
      </Suspense>
    ),
  },
  {
    path: '/product/2',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">로딩 중...</div>}>
        <Product2Page />
      </Suspense>
    ),
  },
  {
    path: '/product/warmth',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">로딩 중...</div>}>
        <ProductWarmthPage />
      </Suspense>
    ),
  },
  {
    path: '/product/recovery',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">로딩 중...</div>}>
        <ProductRecoveryPage />
      </Suspense>
    ),
  },
  {
    path: '/product/vitality',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">로딩 중...</div>}>
        <ProductVitalityPage />
      </Suspense>
    ),
  },
  {
    path: '/product/breath',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">로딩 중...</div>}>
        <ProductBreathPage />
      </Suspense>
    ),
  },
  {
    path: '/product/freshness',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">로딩 중...</div>}>
        <ProductFreshnessPage />
      </Suspense>
    ),
  },
  {
    path: '/product/brain',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">로딩 중...</div>}>
        <ProductBrainPage />
      </Suspense>
    ),
  },
  {
    path: '/board',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">로딩 중...</div>}>
        <BoardPage />
      </Suspense>
    ),
  },
  {
    path: '/board/:id',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">로딩 중...</div>}>
        <BoardDetailPage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">로딩 중...</div>}>
        <NotFoundPage />
      </Suspense>
    ),
  },
];

export default routes;
